import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import {MzEchartsPieComponent} from './mz-echarts-pie/mz-echarts-pie.component';
declare var echarts;//设置echarts全局对象
@Component({
    selector: 'app-echarts',
    templateUrl: './echarts.component.html',
    styleUrls: ['./echarts.component.scss']
})
export class EchartsComponent extends GridBaseCase {   
    constructor() { super(); }   
}
